import React from "react";
import "./CreateCard.css";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

export const CreateCard = ({ label, isTimeTrial = false }) => {
  return (
    <div className={`createcard ${isTimeTrial ? "createcard--timetrial" : ""}`}>
      <div className="createcard__add">
        <AddRoundedIcon sx={{ fontSize: "70px", color: "#747474" }} />
      </div>
      <div className="createcard__content">
        <div>
          <div className="createcard__contenthead">
            <h4>{label}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};
